
import React from 'react';
import { CienCuadrasLogoImg, SpinnerIcon, ExclamationTriangleIcon } from './Icons';

interface SplashScreenProps {
  isEnvironmentReady?: boolean;
  configLoading?: boolean;
  firebaseAuthLoading?: boolean;
  appUserProfileLoading?: boolean;
  error?: string | null;
}

export const SplashScreen: React.FC<SplashScreenProps> = ({ 
  isEnvironmentReady,
  configLoading,
  firebaseAuthLoading,
  appUserProfileLoading,
  error
}) => {
  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4 text-center">
        <CienCuadrasLogoImg />
        <div className="mt-8 p-6 bg-red-50 border border-red-200 rounded-lg max-w-md">
            <ExclamationTriangleIcon className="w-12 h-12 text-red-500 mx-auto mb-4" />
            <h2 className="text-lg font-semibold text-red-800">No se pudo inicializar la aplicación</h2>
            <p className="mt-2 text-sm text-red-700">{error}</p>
            <button
                onClick={() => window.location.reload()}
                className="mt-6 px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
            >
                Reintentar
            </button>
        </div>
      </div>
    );
  }

  let message = "Cargando aplicación...";

  if (isEnvironmentReady === false) {
    message = "Verificando entorno de la aplicación...";
  } else if (configLoading) {
    message = "Cargando configuración de la aplicación...";
  } else if (firebaseAuthLoading) {
    message = "Verificando sesión de usuario...";
  } else if (appUserProfileLoading) {
    message = "Cargando perfil de usuario...";
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
      <CienCuadrasLogoImg />
      <SpinnerIcon className="w-12 h-12 mt-8 text-sky-600" />
      <p className="mt-4 text-lg text-gray-700">{message}</p>
    </div>
  );
};
